import { CopyToClipboard } from '@cloudscape-design/components';
import React from 'react';

interface CopyProps {
  value?: string;
  text?: string;
  showText?: boolean;
  variant?: "icon" | "inline" | "button";

}
const Copy: React.FC<CopyProps> = ({
  value = "",
  text = "ID Copiado",
  variant = "inline",
  showText = true
}) => {

  return (
    <CopyToClipboard
      textToCopy={String(value)}
      variant={variant}
      popoverRenderWithPortal={true}
      copySuccessText={text}
      copyErrorText={'Error en la copia'}
      textToDisplay={variant === "inline" ? showText ? `#ID ${value}` : ` ` : "&nbsp;"}
    />

  );
};

export default Copy;